module.exports = __webpack_public_path__ + "img/stripe.2199af17.png";